module.exports = __webpack_public_path__ + "static/img/repair2.8c5f6a9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/repair2.gif
// module id = awTV
// module chunks = 0